import { ConfirmationService, MessageService } from 'primeng/api';

export function provideAppServices() {
  return [MessageService, ConfirmationService];
}
